module.exports = __webpack_public_path__ + "img/電気回路_1_10_5.0ab659bd.png";